// VerificationContext.js
import { createContext, useContext, useState } from 'react';

const VerificationContext = createContext();

export const VerificationProvider = ({ children }) => {
  const [showMobile, setShowMobile] = useState(false);
  const [showEmail, setShowEmail] = useState(false);

 const openVerification = (type = 'both') => {
  
  if (type === 'mobile') {
    setShowMobile(true);
    return;
  }

  if (type === 'email') {
    setShowEmail(true);
    return;
  }

  if (type === 'both') {
    // Only open one at a time
    setShowMobile(true);
    setShowEmail(false);
  }
};


  return (
    <VerificationContext.Provider 
      value={{ 
        showMobile, 
        setShowMobile, 
        showEmail, 
        setShowEmail, 
        openVerification 
      }}
    >
      {children}
    </VerificationContext.Provider>
  );
};

export const useVerification = () => {
  const context = useContext(VerificationContext);
  if (!context) {
    throw new Error('useVerification must be used within VerificationProvider');
  }
  return context;
};